import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import PageSection from '../../design-system/PageSection';
import { Grid, GridElement } from '../../design-system/Grid';
import Modal from '../../components/Modal';
import { HeadingPara } from '../../design-system/Headings';
import { UnorderedList, ListItem } from '../../design-system/Lists';
import { ResponsiveImage } from '../../design-system/Images';
import { LinkButton } from '../../design-system/Buttons';
import phrasesType from '../../proptypes/phrases';
import { beginDossierPurchaseAction, showDossierPurchaseModalAction } from '../../actions/action-creators';

const ModalGradient = () => <div className="ss_modal-background" />;

export default function PremiumUnlockModal({
  buttonLink,
  phrases,
  visible,
  onCloseClick,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (visible) {
      dispatch(showDossierPurchaseModalAction());
    }
  }, [visible, dispatch]);

  const handleButtonClick = (event) => {
    const { href } = event.target;
    event.preventDefault();
    dispatch(beginDossierPurchaseAction({
      eventCallback: () => { window.location.href = href; },
      eventTimeout: 2000,
    }));
  };

  return (
    <Modal show={visible} onClose={onCloseClick}>
      <section className="ss_modal">
        <PageSection container={false}>
          <ModalGradient />
          <div className="ss_modal_content">
            <Grid
              smVertical
              mdEqualWidth
              lgEqualWidth
              className="sm-ss_column-reverse lg-ss_row"
            >
              <GridElement pxMd myXs className="ss_grid_element--align-self">
                <HeadingPara el="h2" py0 my0>
                  {phrases.lockedTitle}
                </HeadingPara>
                <UnorderedList>
                  <ListItem
                    key={phrases.lockedBullet1}
                    className="ss_color--secondary"
                  >
                    {phrases.lockedBullet1}
                  </ListItem>
                  <ListItem
                    key={phrases.lockedBullet2}
                    className="ss_color--secondary"
                  >
                    {phrases.lockedBullet2}
                  </ListItem>
                  <ListItem
                    key={phrases.lockedBullet3}
                    className="ss_color--secondary"
                  >
                    {phrases.lockedBullet3}
                  </ListItem>
                </UnorderedList>
                <LinkButton href={buttonLink} onClick={handleButtonClick}>
                  {phrases.unlockSingleButtonLabel}
                </LinkButton>
              </GridElement>
              <GridElement pxMd myLg center>
                <ResponsiveImage
                  alt=""
                  src="//images.ctfassets.net/gtqjh9j40j4m/2mwsmSZhvxo6OpuQJv0Rya/c0519e926160d4c48c381011e8817245/dossier-radar-chart.svg"
                />
              </GridElement>
            </Grid>
          </div>
        </PageSection>
      </section>
    </Modal>
  );
}

PremiumUnlockModal.propTypes = {
  phrases: phrasesType.isRequired,
  buttonLink: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};
